import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL_RESOURCE}/api`;
const url2 = `${process.env.REACT_APP_API_URL_RESOURCE}/api/school`;

// 貼堂區
export async function getHighlightList(params: any) {
  return client.post({
    url: `${url}/user_record_highlight/get_list`,
    form: {
      ...params
    }
  });
}

// 點讚
export async function recordAddLike(params: any) {
  return client.post({
    url: `${url}/user_record_highlight/add_like`,
    form: {
      ...params
    }
  });
}

// 貼堂區留言列表
export async function getHighlightCommentList(params: any) {
  return client.post({
    url: `${url}/user_record_highlight/get_comment_list`,
    form: {
      ...params
    }
  });
}

// 貼堂區留言
export async function setHighlightCommentadd(params: any) {
  return client.post({
    url: `${url}/user_record_highlight/add_highlight_comment`,
    form: {
      ...params
    }
  });
}

// 貼堂區留言更改
export async function setHighlightCommentupdate(params: any) {
  return client.post({
    url: `${url}/user_record_highlight/update_highlight_comment`,
    form: {
      ...params
    }
  });
}

// 貼堂區留言删除
export async function deleteHighlightComment(props: any) {
  return client.post({
    url: `${url}/user_record_highlight/delete_highlight_comment`,
    form: {
      ...props
    }
  });
}
// 班別列表
export async function getAllClassList() {
  return client.post({
    url: `${url2}/get_all_class_list`
  });
}
// 年级列表
export async function getGradeList() {
  return client.post({
    url: `${url}/user_record_highlight/get_record_class`
  });
}
// 活动下拉列表
export async function getRecordList(params: any) {
  return client.post({
    url: `${url}/user_record_highlight/get_record_list`,
    form: {
      ...params
    }
  });
}
// 刪除贴堂区作品
export async function delectHightlightRecord(params: any) {
  return client.post({
    url: `${url}/user_record_highlight/delete_record_highlight`,
    form: {
      ...params
    }
  });
}
// 删除所有的贴堂区作品
export async function deleteAllHightlightRecord(params: any) {
  return client.post({
    url: `${url}/user_record_highlight/delete_all_highlight`,
    form: {
      ...params
    }
  });
}
// 获取贴堂区详情信息
export async function getHightlightRecordDetail(params: any) {
  return client.post({
    url: `${url}/user_record_highlight/get`,
    form: {
      ...params
    }
  });
}
